import MasterModal from './MasterModal';

const VendorModal = (props) => {
  return <MasterModal {...props} modalType="vendor" />;
};

export default VendorModal;
